import React, { useEffect, useState} from 'react';
import { connect } from "react-redux";

import { Container } from '../../components/grid/container/Container.styled';
import { Half } from '../../components/grid/half/Half.styled';
import { Link } from "react-router-dom";
import MenuIcon from '../../components/menu-icon/menu-icon';
import { TitleWrap, TitleCenter } from '../../components/ui/title/title.styled';
import { HomeIntroTitle, HomeIntroPlus } from '../../components/home-intro/home-intro.styled';
import { ArticleImg, ArticleText, ArticleTitle, ArticleTitleWrap, ArticleTitleTitle, ArticleTitleDescription, ArticleTitleDonuts, ArticleBottomContainer, ArticleTop, ArticleLogo } from './../article/article.styled';
import { TextWrap } from '../../components/portfolio/clients/nivea/nivea.styled';
import DonutChart from '../../components/ui/donat-chart/donat-chart';
import { BG } from '../../components/grid/bg/bg.style';
import { ShowDesktop, ShowMobile } from '../../components/grid/showHide/showHide.style';
import { BackMobile } from '../../components/ui/back-mobile/back-mobile.styled';
import { Next } from '../../components/ui/next/next.styled';
import { More } from '../../components/ui/more/more.styled';
import Hrefs from '../../components/hrefs/hrefs';
import NotFound from '../not-found/not-found';
import SEO from '../../components/seo/seo';
import Player from '../../components/portfolio/video/video';

const mapStateToProps = state => {
  return {clients: state.clients};
};

const Client = ({ match, clients }) => {
  const [nextArticle, updateNextArticle] = useState(false)
  const [undefinied, updateUndefinied] = useState(false)

  function find(slug) {
    return clients.find(p => p.acf.link === slug);
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  })

  useEffect(() => {
    setTimeout(() => {
      updateUndefinied(true)
    }, 3500)
  }, [])

  useEffect(() => {
    clients.map((p, i) => {
      if(p.acf.link === match.params.slug) {
        const url = clients[i + 1] ? clients[i + 1].acf.link : clients[0].acf.link
        updateNextArticle(url)
      }
    })
  }, [clients, match.params.slug])

  let article = find(match.params.slug);
  return (
    <BG
      color={article !== undefined ? article.acf.bg_color : '#F9F8F6'}
    >
      {
        (undefinied && article === undefined) && (
          <NotFound />
        )
      }
      { article !== undefined && 
        <Container dontReverse={true} isMinHeight={true}>
          <SEO
            title={article.acf.seo ? article.acf.seo.title : ''}
            description={article.acf.seo ? article.acf.seo.description : ''}
            keywords={article.acf.seo ? article.acf.seo.keywords : ''}
            image={article.acf.seo ? article.acf.seo.ogimage : ''}
          />
          <MenuIcon isWhite />
          <BackMobile>
            <Link to={article.acf.landing_link ? article.acf.landing_link : `/#${article.acf.id}`}><svg xmlns="http://www.w3.org/2000/svg" width="16.376" height="16.377" viewBox="0 0 16.376 16.377">
                <path d="M0,0H10.43V10.43" transform="translate(9.001 15.563) rotate(-135)" fill="none" stroke={article.acf.special_color} strokeWidth="2.3"/>
              </svg>
            </Link>
          </BackMobile>
          <Link 
            className={`contact-button`} 
            exact to="/">kontakt</Link>
          <TitleWrap isTransform={true}>
            <TitleCenter color={article.acf.special_color}>
              <span style={{
                color: `#ffffff`
              }} className="icon-signet"></span>
            </TitleCenter>
          </TitleWrap>  
          <Half mobileInitial={true} fullHeight={true}>
            <ShowDesktop>
              <ArticleLogo main src={article.acf.logo} alt={article.acf.title} />
              <HomeIntroPlus>
                <svg xmlns="http://www.w3.org/2000/svg" width="44.44" height="44.439" stroke={`#ffffff`} viewBox="0 0 44.44 44.439">
                  <g transform="translate(-771.5 -71)">
                    <line x2="44.44" transform="translate(771.5 93.22)" fill="none" strokeWidth="10"/>
                    <line x2="44.44" transform="translate(793.72 71) rotate(90)" fill="none" strokeWidth="10"/>
                  </g>
                </svg>
              </HomeIntroPlus>
            </ShowDesktop>
            <ShowMobile>
              <HomeIntroTitle color={article.acf.special_color}>
                <ArticleLogo mobile src={article.acf.logo} alt={article.acf.title} />
              </HomeIntroTitle>
            </ShowMobile>
          </Half>
          <Half mobileInitial={true} center fullHeight={false}>
            <div itemscope itemtype="http://schema.org/NewsArticle">
            <TextWrap>

                          <ArticleTitle
                            isAuthor={true}
                            hasCharts={article.acf.intro.charts}
                          >
                            <ArticleTitleWrap
                              hasCharts={article.acf.intro.charts}
                              color={ article.acf.text_color }
                            >
                              <ArticleTitleTitle isAuthor={true}><h1 itemprop="headline">{article.acf.intro.title}</h1></ArticleTitleTitle>
                              {article.acf.intro.description && <div itemprop="description"><ArticleTitleDescription><Hrefs text={article.acf.intro.description} /></ArticleTitleDescription></div>}
                            </ArticleTitleWrap>
                            {
                              article.acf.intro.charts === true && <ArticleTitleDonuts>
                                {
                                  article.acf.intro.donuts.map(donut => {
                                    return (
                                      <DonutChart 
                                        size={117}
                                        stroke={article.acf.special_color}
                                        bgColor={article !== undefined ? article.acf.bg_color : '#ffffff'}
                                        text={donut.in_chart}
                                        max={donut.in_max}
                                        specialChar={donut.special_char}
                                        textColor={article.acf.text_color ? article.acf.text_color : '#232328'}
                                        undertext={donut.under_chart}
                                      />
                                    )
                                  })
                                }
                              </ArticleTitleDonuts>
                            }
                          </ArticleTitle>
              </TextWrap>
              <div itemprop="articleBody">
                {
                  article.acf.article && article.acf.article.map(el => {
                    switch (el.acf_fc_layout) {
                      case 'text':
                        return (
                          <TextWrap>
                            <ArticleText color={ article.acf.text_color } right={el.right}>
                              <Hrefs text={el.content} />
                            </ArticleText>
                          </TextWrap>
                        )
                      case 'title':
                        return (
                          <TextWrap>
                            <ArticleTitle
                              hasCharts={el.charts}
                            >
                              <ArticleTitleWrap
                                hasCharts={el.charts}
                                color={ article.acf.text_color }
                              >
                                <ArticleTitleTitle ><h1 itemprop="headline">{el.title}</h1></ArticleTitleTitle>
                                {el.description && <div itemprop="description"><ArticleTitleDescription>{el.description}</ArticleTitleDescription></div>}
                              </ArticleTitleWrap>
                              {
                                el.charts === true && <ArticleTitleDonuts>
                                  {
                                    el.donuts.map(donut => {
                                      return (
                                        <DonutChart 
                                          size={117}
                                          stroke={article.acf.text_color ? article.acf.text_color : article.acf.color}
                                          bgColor={article !== undefined ? article.acf.bg_color : '#ffffff'}
                                          text={donut.in_chart}
                                          max={donut.in_max}
                                          specialChar={donut.special_char}
                                          textColor={article.acf.text_color ? article.acf.text_color : '#232328'}
                                          undertext={donut.under_chart}
                                        />
                                      )
                                    })
                                  }
                                </ArticleTitleDonuts>
                              }
                            </ArticleTitle>
                          </TextWrap>
                        )
                      case 'vimeo':
                        return (<Player video={{
                          src: el.url,
                        }} nonMarginable />)
                      case 'img':
                        return (<TextWrap rightZero={true}>
                          <div itemprop="image" itemscope itemtype="http://schema.org/ImageObject">
                            <meta itemprop="height" content={el.img.height}></meta>
                            <meta itemprop="width" content={el.img.width}></meta>
                            <meta itemprop="url" content={el.img.url}></meta>
                            <ArticleImg src={el.img.url} alt={el.img.alt} />
                          </div>
                        </TextWrap>)
                      default:
                        return false;
                    }
                  })
                }
              </div>
            </div>
            <TextWrap>
              { nextArticle && <Next client color={article.acf.special_color}>
                <Link to={`/`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24.004" height="22" viewBox="0 0 24.004 22">
                    <g transform="translate(-20300.998 4512.999)" fill="none">
                      <path d="M20301-4491v-13.937l12-8.064,12,8.064V-4491Z" stroke="none"/>
                      <path d="M 20322.001953125 -4493.998046875 L 20322.001953125 -4503.3359375 L 20313 -4509.38427734375 L 20303.998046875 -4503.3359375 L 20303.998046875 -4493.998046875 L 20322.001953125 -4493.998046875 M 20325.001953125 -4490.998046875 L 20300.998046875 -4490.998046875 L 20300.998046875 -4504.9345703125 L 20313 -4512.99853515625 L 20325.001953125 -4504.9345703125 L 20325.001953125 -4490.998046875 Z" stroke="none" fill={article.acf.special_color}/>
                    </g>
                  </svg><br/>
                  przejdź na home
                </Link>
              </Next>}
              <ArticleBottomContainer>
                <More article={true} noneRotate client color={article.acf.special_color}>
                  <Link to={ `/` }><svg xmlns="http://www.w3.org/2000/svg" width="24.004" height="22" viewBox="0 0 24.004 22">
                    <g transform="translate(-20300.998 4512.999)" fill="none">
                      <path d="M20301-4491v-13.937l12-8.064,12,8.064V-4491Z" stroke="none"/>
                      <path d="M 20322.001953125 -4493.998046875 L 20322.001953125 -4503.3359375 L 20313 -4509.38427734375 L 20303.998046875 -4503.3359375 L 20303.998046875 -4493.998046875 L 20322.001953125 -4493.998046875 M 20325.001953125 -4490.998046875 L 20300.998046875 -4490.998046875 L 20300.998046875 -4504.9345703125 L 20313 -4512.99853515625 L 20325.001953125 -4504.9345703125 L 20325.001953125 -4490.998046875 Z" stroke="none" fill={article.acf.special_color}/>
                    </g>
                  </svg> przejdź na home
                  </Link>
                </More>
                {article.acf.link_to && <More hideMobile={true} noneRotate={true} article={true} color={article.acf.special_color}>
                  { nextArticle && <Link to={article.acf.link_to}> {article.acf.link_to_text} <svg xmlns="http://www.w3.org/2000/svg" width="24.295" height="13.912" viewBox="0 0 24.295 13.912">
                    <path d="M24.3,5.549H4.654L8,1.893,6.035,0,0,6.956l6.035,6.956L8,12.019,4.654,8.363H24.3Z" transform="translate(24.295 13.912) rotate(180)" fill={article.acf.special_color}/>
                  </svg>
                  </Link>}
                </More>}
              </ArticleBottomContainer>
              
            </TextWrap>
          </Half>
        </Container>
      }
     
    </BG>
  )
}

export default connect(mapStateToProps, null)(Client);